import React from 'react';
import { Button } from '@mui/material';

const filterConfig = (Translation: any, onSearch: any, onReset: any, listData: any) => {
  return [
    [
      { type: 'header', label: Translation('event.ebirthday_card.content.filter'), sm: true },
      {
        type: 'custom',
        sm: false,
        render: () => (
          <Button variant="contained" onClick={onReset}>
            {Translation('golbal.filters.reset')}
          </Button>
        ),
      },
      {
        type: 'custom',
        sm: false,
        render: () => (
          <Button variant="contained" color="secondary" onClick={onSearch}>
            {Translation('golbal.filters.search')}
          </Button>
        ),
      },
    ],
    [
      { type: 'input', label: Translation('event.ebirthday_card.content.filter.content'), prop: 'content', sm: false },
      {
        type: 'input',
        label: Translation('event.ebirthday_card.content.filter.modifier'),
        prop: 'modifier',
        sm: false,
      },
      {
        type: 'select',
        label: Translation('event.ebirthday_card.title.filter.title'),
        prop: 'titleId',
        sm: false,
        opts: listData.titleList,
      },
    ],
  ];
};

export default filterConfig;
